import { IThemeDTO } from 'types/theme'
import { IUser } from 'types/user'

const generateThemeResponse = (user: IUser): IThemeDTO => {
  if (user.theme == null) {
    return {
      primary: '#3024E1',
      secondary: '#F0F0F0',
      terciary: '#1A147C',
      baseLogo: '',
      blackLogo: '',
      whiteLogo: '',
    }
  }

  return {
    primary: user.theme.primary.includes('#') ? user.theme.primary : `#${user.theme.primary}`,
    secondary: user.theme.secondary.includes('#') ? user.theme.secondary : `#${user.theme.secondary}`,
    terciary: user.theme.terciary.includes('#') ? user.theme.terciary : `#${user.theme.terciary}`,
    baseLogo: user.theme.baseLogo,
    blackLogo: user.theme.blackLogo,
    whiteLogo: user.theme.whiteLogo,
  } as IThemeDTO
}

export default generateThemeResponse
